import { isDefined } from "@clipboard-health/util-ts";
import { useGeofenceContext } from "@src/appV2/Location/geofence/useGeofence";
import { CurrentShiftStage } from "@src/appV2/redesign/Shift/constants";
import { getShiftCurrentStage } from "@src/appV2/redesign/Shift/WorkerShift/getShiftCurrentStage";
import { type Shift } from "@src/appV2/Shifts/Shift/types";

interface UseShouldShowArrivalTimeCardProps {
  shift: Shift;
}

export function useShouldShowArrivalTimeCard(props: UseShouldShowArrivalTimeCardProps) {
  const { shift } = props;

  const { inside } = useGeofenceContext();

  const { targetArrivalTime, shiftStartAt } = shift.computedArrival ?? {};

  // Check if user has NOT clocked in and is NOT within geofence
  const currentShiftStage = getShiftCurrentStage(shift);
  const hasNotClockedIn = currentShiftStage === CurrentShiftStage.NOT_STARTED;
  const isNotInGeofence = !inside;
  const shouldShowArrivalTimeCard = hasNotClockedIn && isNotInGeofence;

  // Don't render anything if conditions aren't met or no arrival time
  return isDefined(targetArrivalTime) && isDefined(shiftStartAt) && shouldShowArrivalTimeCard;
}
